import { isLocal } from "../utils/env";
import { log } from "../utils/logger";

import { isDev } from "../utils/env";

import async from "../components/Async";
import {
  Settings as AdminIcon,
  List as ListIcon,
  Users as UsersIcon,
  User as UserIcon,
  Layout as TemplatesIcon,
} from "react-feather";

// Auth
// import Register from "../pages/auth/Register";
import SignIn from "../pages/auth/SignIn";
import PasswordReset from "../pages/auth/PasswordReset";
import RequestPasswordReset from "../pages/auth/RequestPasswordReset";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

// Account
import Account from "../pages/account/profile";
import ChangePassword from "../pages/account/Password";

// Administration
import AdminUserPermissions from "../pages/administration/UserPermissions";
import AdminSeedLists from "../pages/administration/SeedList";
import Whitelist from "../pages/administration/Whitelist";
import MbIdLookUp from "../pages/administration/MbIdLookUp";
import PreferenceLookUp from "../pages/administration/PreferenceLookUp";
import SpamCheck from "../pages/administration/SpamCheck";
//import ecsDashboard from "../pages/administration/ECS Dashboard";

import CampaignList from "../pages/campaign/CampaignList";
import CampaignOnOff from "../pages/administration/CampaignOnOff";
import OnDemand from "../pages/onDemand/ScriptEditing";
// Templates
const Templates = async(() => import("../pages/templates/ScriptEditing"));
const Approval = async(() => import("../pages/templates/ScriptApproval"));
const History = async(() => import("../pages/templates/ScriptHistory"));
const Editor = async(() => import("../pages/templates/ScriptEditor"));

// Dashboards - lazy load
const Results = async(() => import("../pages/dashboards/Results"));
const MobileOriginated = async(() => import("../pages/dashboards/MobileOriginated"));
const MultiFactor = async(() => import("../pages/dashboards/MultiFactor"));
const UpSell = async(() => import("../pages/dashboards/UpSell"));
const Bidgely = async(() => import("../pages/dashboards/bidgely"));
const CreditTransfer = async(() => import("../pages/dashboards/CreditTransfer"));

const campaignRoutes = {
  path: "/campaign",
  name: "Campaign Switchboard",
  icon: TemplatesIcon,
  isPrivate: true,
  component: CampaignList,
};

const onDemandRoutes = {
  path: "/onDemand",
  name: "On Demand",
  icon: TemplatesIcon,
  component: OnDemand,
};

// Routes
const landingRoutes = {
  path: "/",
  name: "Sign In",
  component: SignIn,
  children: null,
};

const dashboardRoutes = {
  path: "/dashboard",
  name: "Dashboard",
  header: "Dashboards",
  // badgeColor: "primary",
  // badgeText: "5",
  icon: ListIcon,
  containsHome: true,
  isPrivate: true,
  children: [
    {
      path: "/dashboard/results",
      name: "Results",
      restrictedToLevel: 1,
      component: Results,
    },
    {
      path: "/dashboard/Bidgely",
      name: "Bidgely Results",
      restrictedToLevel: 1,
      component: Bidgely,
    },

    {
      path: "/dashboard/mobile-originated",
      name: "Mobile Originated",
      restrictedToLevel: 1,
      component: MobileOriginated,
    },
    {
      path: "/dashboard/up-sell",
      name: "Up Sell",
      restrictedToLevel: 1,
      component: UpSell,
    },
    {
      path: "/dashboard/multi-factor",
      name: "Multi-Factor Authentication",
      restrictedToLevel: 1,
      component: MultiFactor,
    },
    {
      path: "/dashboard/creditTransfer",
      name: "Credit Transfer",
      restrictedToLevel: 1,
      component: CreditTransfer,
    },
  ],
};

const templateRoutes = {
  path: "/templates",
  name: "Script Management",
  icon: TemplatesIcon,
  isPrivate: true,
  children: [
    {
      path: "/templates/list/",
      name: "Script Templates",
      component: Templates,
      restrictedToLevel: 1,
    },
  ],
};

const accountRoutes = {
  path: "/account/profile",
  name: "Account",
  icon: UserIcon,
  header: "Settings",
  isPrivate: true,
  component: Account,
};

const passwordRoutes = {
  path: "/restricted/password",
  name: "Password Manager",
  icon: UserIcon,
  specialUserRestrictions: (user) => {
    if (/@ameren.com/.test(user.email_vch)) {
      return false;
    }
    return true;
  },
  component: ChangePassword,
};

const administrationRoutes = {
  path: "/admin",
  name: "Administration",
  icon: AdminIcon,
  isPrivate: true,
  restrictedToLevel: 1,
  children: [
    {
      path: "/admin/manage-users",
      name: "Manage User Permissions",
      component: AdminUserPermissions,
      restrictedToLevel: 4,
    },
    {
      path: "/admin/manage-whitelist",
      name: "Manage Whitelist",
      component: Whitelist,
      restrictedToLevel: 3,
      environments: ["local", "dev"],
    },
    {
      path: "/admin/seed-lists",
      name: "Manage Seed Lists",
      component: AdminSeedLists,
      restrictedToLevel: 3,
    },
    {
      path: "/admin/mbid-lookup",
      name: "MBID Look Up",
      component: MbIdLookUp,
      restrictedToLevel: 4,
    },
    {
      path: "/admin/preference-lookup",
      name: "Preference Look Up",
      component: PreferenceLookUp,
      restrictedToLevel: 3,
    },
    {
      path: "/admin/spam-check",
      name: "Manage Spam Emails",
      component: SpamCheck,
      restrictedToLevel: 3,
    },
    /*{
      path: "/admin/ecsDashboard",
      name: "ECS Dashboard",
      component: ecsDashboard,
      restrictedToLevel: 4,
    },*/
    {
      path: "/admin/campaignOnOff",
      name: "Campaign On/Off",
      component: CampaignOnOff,
      restrictedToLevel: 3,
    },
  ],
};

const authRoutes = {
  path: "/auth",
  name: "Auth",
  icon: UsersIcon,
  badgeColor: "secondary",
  badgeText: "internal",
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    // Currently disabled self-registration
    // {
    //   path: "/auth/register",
    //   name: "Register",
    //   component: Register,
    // },

    {
      path: "/auth/request-reset",
      name: "Reset Password",
      component: RequestPasswordReset,
    },

    {
      path: "/auth/password-reset",
      name: "Reset Password",
      component: PasswordReset,
    },
    {
      path: "/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/500",
      name: "500 Page",
      component: Page500,
    },
  ],
};

// These routes are not visible in the sidebar
const hiddenRoutes = {
  path: null,
  name: "Private",
  children: [
    {
      path: "/templates/approval",
      name: "Script Approvals",
      component: Approval,
      restrictedToLevel: 3,
      isPrivate: true,
    },
    {
      path: "/templates/history",
      name: "Script History",
      component: History,
      restrictedToLevel: 1,
      isPrivate: true,
    },
    {
      path: "/templates/Editor",
      name: "Script Editor",
      component: Editor,
      restrictedToLevel: 1,
      isPrivate: true,
    },
  ],
};

// Landing specific routes
export const landing = [landingRoutes];

//on demand routes
export const onDemand = [onDemandRoutes];

// Dashboard specific routes
export const dashboard = [dashboardRoutes];

export const templates = [templateRoutes];

// Auth specific routes
export const auth = [authRoutes];

// Account specific routes
export const account = [accountRoutes];

// Administration specific routes
export const administration = [administrationRoutes];

// Hidden Password Route
export const password = [passwordRoutes];

// Routes that won't appear in SideNav
export const hidden = [hiddenRoutes];

// IL Credit Campaign
export const campaign = [campaignRoutes];

// All routes - order determines side nav position
const AllRoutes = [
  dashboardRoutes,
  templateRoutes,
  campaignRoutes,
  onDemandRoutes,
  accountRoutes,
  passwordRoutes,
  administrationRoutes,
];

if (isLocal()) {
  log("---- Adding local test routes ----");
  AllRoutes.push();
}
if (isDev()) {
  log("---- Adding Dev test routes ----");
  AllRoutes.push();
}

export default AllRoutes;
